import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbTab } from '../../types/pbBlocks';
import { parseStyleString, getAdvanced, getBackgroundImages, getBackgroundImagesForLozad } from '../utils';

export type TabItemType = ContentTypeObject & PbTab;

/**
 * Aggregates the configuration of a tab item element.
 * @param node
 */
export function tabItemConfigAggregator(node: CustomHtmlElement): TabItemType {
    const style = parseStyleString(node.attributes.style);

    const backgroundImages = getBackgroundImagesForLozad(node);

    return {
        ...getAdvanced(node, style),
        ...getBackgroundImages(node, style),
        desktopImage: backgroundImages.desktopImage,
        mobileImage: backgroundImages.mobileImage,
        minHeight: style?.minHeight,
        tabName: node.attributes['data-tab-name'],
        uniqueID: node.attributes['data-pb-style'],
        verticalAlignment: style?.justifyContent,
    };
}
